import { Box, Link, Typography } from '@mui/material'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'
import { useNavigate } from 'react-router-dom'
import colors from 'styles/colors'
import RowStack from './RowStack'
import { MY_JOURNEY } from 'routes/constants'

const StyledBreadcrumbs = ({ crumbs = [], containerSx = {} }) => {
  const navigate = useNavigate()

  const handleClick = (event, crumb) => {
    event.preventDefault()
    if (crumb.path) navigate(crumb.path, { state: crumb?.state })
  }

  const linkSx = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.MutedTeal50,
    padding: '4px 8px',
    borderRadius: 20,
    textDecoration: 'none'
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%',
        paddingBottom: 8,
        paddingTop: 3,
        ...containerSx
      }}>
      <RowStack spacing={4}>
        <Link
          href='#'
          onClick={event => handleClick(event, { path: MY_JOURNEY })}
          sx={{
            ...linkSx,
            padding: 4,
            width: 24,
            height: 24
          }}>
          <HomeRoundedIcon sx={{ fontSize: 16 }} />
        </Link>

        {crumbs.map((crumb, i) => {
          const lastCrumb = i === crumbs.length - 1
          return (
            <Link
              key={i}
              href='#'
              onClick={event => handleClick(event, crumb)}
              sx={{
                ...linkSx,
                ...(lastCrumb && {
                  color: colors.Grey400,
                  backgroundColor: colors.White,
                  cursor: 'default'
                })
              }}>
              <RowStack spacing={2}>
                {!lastCrumb && (
                  <ArrowBackIosNewRoundedIcon sx={{ fontSize: 12 }} />
                )}
                <Typography variant='formTagText'>{crumb?.label}</Typography>
              </RowStack>
            </Link>
          )
        })}
      </RowStack>
    </Box>
  )
}

export default StyledBreadcrumbs
